import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getRows = store => store[NAME].rows;
export const getDateFormat = store => store[NAME].dateFormat;
export const getTypes = store => store[NAME].types;
export const getSubtypes = store => store[NAME].subtypes;